import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-add-button",
    styleUrls: ["./add-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./add-button.component.html"
})
export class AddButtonComponent {

}
